import { render, staticRenderFns } from "./DicInfo.vue?vue&type=template&id=3b959733"
import script from "./DicInfo.vue?vue&type=script&lang=js"
export * from "./DicInfo.vue?vue&type=script&lang=js"
import style0 from "./DicInfo.vue?vue&type=style&index=0&id=3b959733&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports